<template>
  <v-container>
    <v-row>
      <!-- Columna para la medida -->
      <v-col cols="12" sm="12" md="4" lg="4" class="d-flex align-items-center">
        <p class="txtdata">
          {{ data.nombre }} - {{ data.datos.medida }} - Color:
          {{ data.color.color }}
        </p>
      </v-col>

      <!-- Columna para los botones y el campo de texto -->

      <v-col cols="4" sm="6" md="4" lg="4" class="d-flex align-items-center">
        <v-text-field
          label="Cantidad"
          v-model.number="data.datos.cantidad"
          style="font-size: smaller"
          placeholder="cantidad"
          variant="solo"
          class="txtdata"
        ></v-text-field>
      </v-col>
      <v-col cols="4" sm="4" md="2" lg="2">
        <v-btn
          class="txtbutton txtdata"
          variant="flat"
          color="green-darken-3"
          @click="incrementarCantidad()"
          size="small"
          >+</v-btn
        >
        <v-spacer style="height: 5px"></v-spacer>
        <v-btn
          class="txtbutton txtdata"
          variant="flat"
          color="yellow-darken-3"
          @click="decrementarCantidad()"
          size="small"
          >-</v-btn
        >
        <v-spacer style="height: 5px"></v-spacer>
        <v-btn
          class="txtbutton"
          variant="flat"
          color="red-darken-3"
          @click="removeProductCart(data.id)"
          size="small"
          ><span class="mdi mdi-delete-forever"></span
        ></v-btn>
      </v-col>
      <v-col cols="4" sm="2" md="2" lg="2">
        <p class="txtdata">P.U.</p>
        <p
          v-if="data.datos.cantidad >= 1000"
          class="txtdata"
          style="color: green"
        >
          ${{ valorUnitarioMillar }}
        </p>
        <p v-else class="txtdata" style="color: green">
          ${{ valorUnitarioNormal }}
        </p>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapActions } from 'vuex';
export default {
  props: {
    data: {
    type: Object,
    default: function() {
      return {};
    }
  },
  },
  mounted() {},
  computed: {
    valorUnitarioMillar() {
      const precioMillar = parseFloat(this.data.datos.precioMillar);
      const costoAdicional = parseFloat(this.data.color.costoAdicional);
      return (precioMillar + costoAdicional).toFixed(2);
    },
    valorUnitarioNormal() {
      const precio = parseFloat(this.data.datos.precio);
      const costoAdicional = parseFloat(this.data.color.costoAdicional);
      return (precio + costoAdicional).toFixed(2);
    },
  },
  methods: {
    incrementarCantidad(index) {
      if (this.data.datos.cantidad < 10000) {
        this.data.datos.cantidad++;
      }
    },
    decrementarCantidad(index) {
      if (this.data.datos.cantidad > 1) {
        this.data.datos.cantidad--;
      }
    },
    ...mapActions(['addToCart', 'removeFromCart']),

    addProductToCart(id, nombre, data, color) {
      var item = {
        id: id,
        nombre: nombre,
        datos: data,
        color: color,
      };
      this.addToCart(item);
    },
    removeProductCart(id) {
      this.removeFromCart(id);
    },
  },
};
</script>

<style scoped>
.txtdata {
  font-family: Arial, Helvetica, sans-serif;
  font-weight: 600;
}
</style>
